import React from 'react'
import clsx from 'clsx'
import { Modal as AntModal } from 'antd'
import { ModalProps as AntModalProps } from 'antd/lib/modal'
import { CloseButton } from '../CloseButton/CloseButton'

import styles from './_.module.css'

export type ModalProps = {
  subheader?: string
  size?: 'sm' | 'md' | 'lg'
} & AntModalProps

const sizeToWidthMap = {
  sm: '420px',
  md: '640px',
  lg: '800px'
}

export const Modal: React.FC<ModalProps> = ({
  children,
  className,
  afterClose,
  footer,
  title,
  closable = true,
  visible,
  okText = 'OK',
  onOk,
  okButtonProps,
  onCancel,
  cancelText,
  cancelButtonProps = { type: 'link' },
  destroyOnClose,
  width,
  closeIcon,
  wrapClassName,
  centered = false,
  zIndex = 1000,
  maskClosable = true,
  modalRender,
  bodyStyle,
  subheader,
  size = 'md'
}) => {
  const modalWidth = width || sizeToWidthMap[size]

  let closeIconDisplay
  if (closable && closeIcon) {
    closeIconDisplay = (
      <button className={styles.btn} onClick={onCancel}>
        {closeIcon}
      </button>
    )
  } else if (closable && !closeIcon) {
    closeIconDisplay = <CloseButton size="lg" onClose={onCancel} />
  } else {
    closeIconDisplay = null
  }

  const header = title && (
    <div className={styles.header}>
      <div className={styles.headerTop}>
        <h2
          className={clsx(styles.title, {
            [styles[size]]: size
          })}
        >
          {title}
        </h2>
        {closeIconDisplay}
      </div>
      {subheader && (
        <p
          className={clsx(styles.subheader, {
            [styles[size]]: size
          })}
        >
          {subheader}
        </p>
      )}
    </div>
  )

  return (
    <AntModal
      className={clsx(styles.modal, className, {
        [styles.noHeader]: !title,
        [styles.defaultCloseIcon]: !title,
        [styles.noFooter]: footer === null
      })}
      wrapClassName={wrapClassName}
      afterClose={afterClose}
      destroyOnClose={destroyOnClose}
      footer={footer}
      title={header}
      visible={visible}
      maskClosable={maskClosable}
      onOk={onOk}
      okText={okText}
      onCancel={onCancel}
      cancelText={cancelText}
      okButtonProps={okButtonProps}
      cancelButtonProps={cancelButtonProps}
      width={modalWidth}
      centered={centered}
      zIndex={zIndex}
      modalRender={modalRender}
      bodyStyle={bodyStyle}
      closable={closable}
      closeIcon={closeIcon}
    >
      {children}
    </AntModal>
  )
}
